'use strict';exports.__esModule = true;exports.getArticleById = exports.receiveArticles = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var receiveArticles = (0, _reduxAct.createAction)('/RECEIVE_ARTICLES');
var receiveArticlesSuccess = (0, _reduxAct.createAction)('/RECEIVE_ARTICLES_SUCCESS');
var receiveArticlesFail = (0, _reduxAct.createAction)('/RECEIVE_ARTICLES_FAIL');
var getArticleById = (0, _reduxAct.createAction)('/GET_ARTICLE_BY_ID');
var getArticleByIdSuccess = (0, _reduxAct.createAction)('/GET_ARTICLE_BY_ID_SUCCESS');
var getArticleByIdFail = (0, _reduxAct.createAction)('/GET_ARTICLE_BY_ID_FAIL');

var initialState = {
  loading: false,
  loaded: false,
  articles: [] };


var receiveHandlerSuccess = function receiveHandlerSuccess(state, response) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    articles: response.data });};


var receiveHandlerFail = function receiveHandlerFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Aritcle load fail');
  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error });

};

var fetchReceive = function fetchReceive(lang) {return _axios2.default.get('/articles?lang=' + lang).then(receiveArticlesSuccess, receiveArticlesFail);};

var receiveHandler = function receiveHandler(state, lang) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchReceive, lang));};

var getArticleByIdHandlerSuccess = function getArticleByIdHandlerSuccess(state, _ref) {var response = _ref.response,lang = _ref.lang;
  var isValidArticle = (0, _get2.default)(response, 'data.lang') === lang || lang === 'fr';

  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    article: isValidArticle ? response.data : null,
    error: isValidArticle ? null : { status: 404, message: 'Not found' } });

};

var getArticleByIdHandlerFail = function getArticleByIdHandlerFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Load article by ID fail');
  error.status = response.response.status;

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error });

};

var fetchReceiveArticle = function fetchReceiveArticle(id, lang) {return _axios2.default.get('/articles/' + id).
  then(function (response) {return getArticleByIdSuccess({ response: response, lang: lang });}, getArticleByIdFail);};

var getArticleByIdHandler = function getArticleByIdHandler(state, _ref2) {var id = _ref2.id,lang = _ref2.lang;return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchReceiveArticle, id, lang)));};

var articles = (0, _reduxAct.createReducer)(function (on) {
  on(receiveArticles, receiveHandler);
  on(receiveArticlesSuccess, receiveHandlerSuccess);
  on(receiveArticlesFail, receiveHandlerFail);
  on(getArticleById, getArticleByIdHandler);
  on(getArticleByIdSuccess, getArticleByIdHandlerSuccess);
  on(getArticleByIdFail, getArticleByIdHandlerFail);
}, initialState);exports.


receiveArticles = receiveArticles;exports.
getArticleById = getArticleById;exports.default =


articles;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/articles.js
// module id = 581
// module chunks = 0